
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { TransactionGrid } from "../TransactionGrid";
import { useUserProfile } from "@/hooks/useUserProfile";

export const ReturnsTab = () => {
  const { data: profile } = useUserProfile();

  const { data: transactions, isLoading } = useQuery({
    queryKey: ["returns-transactions"],
    queryFn: async () => {
      if (!profile?.id) {
        throw new Error("Utilisateur non connecté");
      }

      const { data, error } = await supabase
        .from("poultry_transactions")
        .select(`
          *,
          stock_items(*)
        `)
        .eq("transaction_type", "return")
        .eq("created_by", profile.id)
        .order("created_at", { ascending: false });

      if (error) throw error;
      return data;
    },
    enabled: !!profile?.id
  });

  return (
    <TransactionGrid
      transactions={transactions || []}
      isLoading={isLoading}
    />
  );
};
